export const GET_AIRLINE_SUCCESS = "GET_AIRLINE_SUCCESS";
export const GET_AIRPLANES_SUCCESS = "GET_AIRPLANES_SUCCESS";
export const GET_AIRPORTS_SUCCESS = "GET_AIRPORTS_SUCCESS";
export const GET_DETAIL_AIRLINE_SUCCESS = "GET_DETAIL_AIRLINE_SUCCESS";
export const GET_DETAIL_AIRPLANES_SUCCESS = "GET_DETAIL_AIRPLANES_SUCCESS";
export const GET_DETAIL_AIRPORTS_SUCCESS = "GET_AIRPLANES_SUCCESS";
export const GET_ALL_ADMIN_SUCCESS = "GET_ALL_ADMIN_SUCCESS";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_DETAIL_PRODUCT_SUCCESS = "GET_DETAIL_PRODUCT_SUCCESS";
export const GET_MYBOOKING_SUCCESS = "GET_MYBOOKING_SUCCESS";
// export const GET_USER_PENDING = "GET_USER_PENDING";
export const GET_DETAIL_USER_SUCCESS = " GET_DETAIL_USER_SUCCESS";
// export const GET_USER_FAILED = "GET_USER_FAILED";
